import { styled } from '@mui/material/styles'
import { FC } from 'react'
import { AppBarProps, AppBar as RaAppBar } from 'react-admin'
import { XxllncAiLogo } from '../components/Icons'
import { color, themeColor } from './themes'
import { UserMenu } from './UserMenu'

const AppBar: FC<AppBarProps> = (props) => (
  <StyledAppBar
    className={classes.root}
    container='div'
    elevation={0}
    userMenu={<UserMenu />}
    {...props}
  >
    <div className={classes.headerContainer}>
      <XxllncAiLogo className={classes.logo} size="md" />
    </div>
    <span className={classes.spacer} />
  </StyledAppBar>
)

const PREFIX = 'xxllncAppBar'

const classes = {
  root: `${PREFIX}-root`,
  spacer: `${PREFIX}-spacer`,
  headerContainer: `${PREFIX}-headerContainer`,
  logo: `${PREFIX}-logo`,
}

const StyledAppBar = styled(RaAppBar)(() => ({
  [`&.${classes.root}`]: {
    backgroundColor: color.white,
    borderBottom: '1px solid ' + themeColor.slate10,
  },
  ['& .RaAppBar-toolbar']: {
    height: 48,
    minHeight: 48,
  },
  ['& .RaAppBar-toolbar button svg']: {
    color: themeColor.blue,
  },
  [`& .${classes.spacer}`]: {
    flex: 1,
  },
  [`& .${classes.headerContainer}`]: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.logo}`]: {
    height: 28,
    width: 'auto',
  },
}))

export default AppBar
